import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Routes } from 'src/router/Routes';
import LockIcon from '@mui/icons-material/Lock';
import { Button, Card, CardContent, Paper, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

interface Props {
  remainingRent?: string;
  payoutLocked?: boolean;
  assetId?: string;
  spvId?: string;
}

export const RemainingBalanceFromLastPayment: FC<Props> = ({ remainingRent, payoutLocked, assetId, spvId }) => {
  const [t] = useTranslation();
  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 500, mb: 0 }}>
            {t('asset.payout.tagline')}
          </Typography>
          <Typography variant="body1">{t('asset.payout.title')}</Typography>
          <Grid container>
            <Grid flexGrow={1}>
              <Paper sx={{ mb: 3, px: 2, py: 2, my: 2, minWidth: 200, backgroundColor: '#e5e7eb', display: 'inline-flex' }}>
                <Typography flexGrow={1} variant="body1">
                  €
                </Typography>
                <Typography variant="body1">{remainingRent ?? '0.00'}</Typography>
              </Paper>
            </Grid>
            <Grid container alignItems="center">
              <Tooltip title={payoutLocked ? t('asset.payout.onePayoutAllowed') : null}>
                <span>
                  <Button
                    startIcon={payoutLocked ? <LockIcon /> : ''}
                    variant="contained"
                    to={Routes.PAYMENT.RENT.replace(':spvId', spvId ?? '').concat('?assetId=', assetId ?? '')}
                    component={Link}
                    disabled={payoutLocked}
                  >
                    {t('asset.payout.button.pay')}
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
